import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { NSGridModule } from '@norfolk-southern/accessns-components';

import { DialogFooterModule } from '@ruby/shared/dialogs/dialog-footer/dialog-footer.module';
import { DialogHeaderModule } from '@ruby/shared/dialogs/dialog-header/dialog-header.module';
import { LoadTrainConfirmationDialog } from '@ruby/shared/dialogs/unit-train/load-train-confirmation/components/load-train-confirmation.dialog';
import { ShipperProfileDialog } from '@ruby/shared/dialogs/unit-train/load-train-confirmation/components/shipper-profile/shipper-profile.dialog';
import { LoadTrainConfirmationContainer } from '@ruby/shared/dialogs/unit-train/load-train-confirmation/containers/load-train-confirmation.container';
import { ShipperProfileContainer } from '@ruby/shared/dialogs/unit-train/load-train-confirmation/containers/shipper-profile/shipper-profile.container';
import { PipesModule } from '@ruby/shared/pipes/pipes.module';

@NgModule({
  declarations: [
    LoadTrainConfirmationContainer,
    LoadTrainConfirmationDialog,
    ShipperProfileContainer,
    ShipperProfileDialog
  ],
  imports: [
    CommonModule,
    DialogHeaderModule,
    DialogFooterModule,
    MatButtonModule,
    NSGridModule,
    MatRadioModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDialogModule,
    PipesModule
  ]
})
export class LoadTrainConfirmationDialogModule {}
